<template>
  <div class="content">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item label="文件名称：">
        <el-input v-model="searchForm.file_name" placeholder="请输入文件名称"></el-input>
      </el-form-item>
      <el-form-item label="文件类型：">
        <el-select v-model="searchForm.file_type" clearable placeholder="请选择">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addDialog = true">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="file_name" label="文件夹名称" width="220"></el-table-column>
      <el-table-column prop="file_type" label="文件类型" width="180"></el-table-column>
      <el-table-column label="发布日期" width="140">
        <template slot-scope="scope">
          <span>{{$timeStamp(scope.row.publish_time,false)}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作人">
        <template slot-scope="scope">
          <span>{{scope.row.last_admin_username}}</span>
          <span style="margin-left: 10px;">{{$timeStamp(scope.row.last_admin_time)}}</span>
        </template>
      </el-table-column>

      <el-table-column label="启用状态" width="140">
        <template slot-scope="scope">
          <el-switch 
            v-model="scope.row.status" 
            active-color="#13ce66" 
            :active-value="1" 
            :inactive-value="0" 
            @change="changeStatus($event,scope.row.id)">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text">查看并下载</el-button>
          <el-button type="text" size="small" @click="fileUpdata(scope.row)">更新</el-button>
          <!-- <el-button type="text" size="small">下载</el-button> -->
          <el-button type="text" size="small" @click="fileDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>

    <!-- 新增对话框 -->
    <el-dialog title="新增文件" :visible.sync="addDialog">
      <el-form :model="crteateForm">
        <el-form-item label="文件名称" style="width:340px;" :label-width="formLabelWidth">
          <el-input v-model="crteateForm.file_name" placeholder="请输入文件名称" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="文件类型" :label-width="formLabelWidth">
          <el-select v-model="crteateForm.file_type" clearable placeholder="请选择">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布日期" :label-width="formLabelWidth">
          <el-date-picker v-model="crteateForm.publish_time" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="上传文件" :label-width="formLabelWidth">
          <el-upload
            :data="auditUploadData"
            action="https://yjapi.ciwei.com/api.php?do=admin_file_upload"
            :file-list="fileList"
            :limit="1"
            :on-remove="fileHandleRemove"
            :on-success="fileHandleSuccess">
            <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!-- 更新对话框 -->
    <el-dialog title="更新文件" :visible.sync="updataDialog">
      <el-form :model="updataForm">
        <el-form-item label="文件名称" style="width:340px;" :label-width="formLabelWidth">
          <el-input v-model="updataForm.file_name" placeholder="请输入文件名称" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="文件类型" :label-width="formLabelWidth">
          <el-select v-model="updataForm.file_type" clearable placeholder="请选择">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件日期" :label-width="formLabelWidth">
          <el-date-picker v-model="updataForm.publish_time" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="上传文件" :label-width="formLabelWidth">
          <el-upload
            :data="auditUploadData"
            action="https://yjapi.ciwei.com/api.php?do=admin_file_upload"
            :file-list=" updataFileList"
            :limit="1"
            :on-remove="updataHandleRemove"
            :on-success="updataHandleSuccess">
            <div>
              <span style="margin-right:15px;color:#2888FF;" v-if="updataFileList.length==0">{{updataForm.file_start_name}}</span>
              <el-button type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
            </div>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updataDialog = false">取 消</el-button>
        <el-button type="primary" @click="updataSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from "./api";
import {timestampToTime} from "@/mixins/tools.js"
import tokenService from "@/utils/services/token_service";
export default {
  mixins: [timestampToTime],
  name: "CountryBase",
  inject: ['reload'],
  data() {
    return {
      searchForm: {
        page: 1,
        pagesize: 10,
      },
      tableData: [],
      currentPage: 1,
      totalList: null,
      addDialog: false,
      updataDialog: false,
      formLabelWidth: '120px',
      crteateForm: {},
      updataForm: {},
      form: {},
      value1: '',
      typeOptions: [
        {
          label: '风险评估'
        },
        {
          label: '风险预警'
        },
        {
          label: '安全培训'
        },
        {
          label: '日常管理'
        },
        {
          label: '应急处置'
        },
      ],
      fileList: [],
      updataFileList: [],
      auditUploadData: {
        sid: tokenService.getToken(),
        type: 5,
        dir: 'sec_system_files'
      },
    };
  },
  created() {
    this.getFilesList()
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    // 获取list
    async getFilesList() {
      let params = {
        page: this.searchForm.page,
        pagesize: this.searchForm.pagesize,
      }
      if(this.searchForm.file_name){
        params.file_name = this.searchForm.file_name
      }
      if(this.searchForm.file_type){
        params.file_type = this.searchForm.file_type
      }
      let res = await api.filesList(params)
      this.tableData = res.list
      this.totalList = res.recordcount;
      // this.pageSize = res.pagecount;
    },
    handleSizeChange(val) {
      this.searchForm.pagesize = val
      this.getFilesList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.searchForm.page = val
      this.getFilesList()
    },
    // list搜索
    search(){
      this.currentPage = 1
      this.searchForm.page = 1
      this.getFilesList()
    },
    // 新增 上传文件-删除
    fileHandleRemove(file, fileList) {
      this.fileList = []
    },
    // 新增 上传文件成功
    fileHandleSuccess(res, file) {
      if(res.error_code != 0) {
        this.fileList = []
        this.$message.error(res.error_message)
      }else {
        this.fileList.push({name: this.crteateForm.file_name, url: res.file})
        this.crteateForm.file_url = res.file
      }
    },
    // 新增提交
    async addSubmit(){
      this.crteateForm.publish_time/=1000
      console.log(this.crteateForm.publish_time);
      await api.filesCreate(this.crteateForm)
      window.location.reload()
      this.addDialog = false
      this.fileList = []
    },
    // 删除文件
    fileDelete(id){
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await api.fileDelete({id:id})
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        setTimeout(()=>{window.location.reload()},300)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    // 更新文件
    async fileUpdata(row){
      console.log(row);
      this.$set(this.updataForm,'id',row.id)
      this.$set(this.updataForm,'file_name',row.file_name)
      this.$set(this.updataForm,'file_start_name',row.file_name)
      this.$set(this.updataForm,'file_type',row.file_type)
      this.$set(this.updataForm,'publish_time',row.add_time*1000)
      this.updataDialog = true
    },
    // 更新 上传文件成功
    updataHandleSuccess(res, file) {
      if(res.error_code != 0) {
        this.updataFileList = []
        this.$message.error(res.error_message)
      }else {
        console.log(res.file);
        this.updataFileList.push({name: this.updataForm.file_name, url: res.file})
        this.updataForm.file_url = res.file
      }
    },
    // 更新 上传文件-删除
    updataHandleRemove(file, fileList) {
      this.updataFileList = []
    },
    // 更新 提交
    async updataSubmit(){
      this.updataForm.publish_time/=1000
      console.log(this.updataForm);
      await api.fileEdit(this.updataForm)
      window.location.reload()
      this.updataDialog = false
      this.updataFileList = []
    },
    // 改变状态
    async changeStatus(event,id){
      await api.fileEdit({
        id: id,
        status: event
      })
      // window.location.reload()
    },
    // 查看文件
    handleClick(row){
      // console.log(row);
      window.open(row.file_url,"","_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 10px 20px;
}
.content{
  background-color: #fff;
  margin: 15px;
  padding: 15px;
  height: 100%;
}
</style>